<template>
    <v-sheet
        class="d-flex flex-column pa-4 pt-2"
    >
        <div>
            <v-fade-transition>
                <v-alert
                    v-show="error"
                    :text="error_text"
                    class="mb-6 text-caption"
                    density="compact"
                    icon="mdi-alert-circle"
                    variant="tonal"
                />
            </v-fade-transition>
        </div>
        <div class="text-subtitle-1 text-medium-emphasis mb-4">{{ translate('common.confirm_ocr_number') }}</div>
        <TextField
            v-model:input="ocr"
            v-model:valid="valid_ocr"
            :label="translate('common.ocr_or_reference_number')"
            :rules="[(v) => validate_ocr(v)]"
            type="text"
        />
        <v-divider class="mt-2 mx-n4" />
        <div class="d-flex justify-end mt-4">
            <v-btn
                :disabled="!valid_ocr"
                :loading="loading"
                @click="get_ocr"
                color="primary"
                variant="flat"
            >
                {{ translate('common.continue') }}
            </v-btn>
        </div>
    </v-sheet>
</template>

<script>
import TextField from '@old/components/input/TextField.vue'
import { locales_mixin } from '@old/mixins/locales_mixin'
import { rules_mixin } from '@old/mixins/rules_mixin'
import { api_mixin } from '@old/mixins/api_mixin'
import { mapActions, mapState } from 'vuex'
import { utils_mixin } from '@old/mixins/utils_mixin'

export default {
    name: 'PaymentOcr',
    props: {},
    mixins: [api_mixin, locales_mixin, rules_mixin, utils_mixin],
    components: { TextField },
    data() {
        return {
            ocr: '',
            valid_ocr: false,
            error: false,
            error_text: '',
            loading: false,
        }
    },
    computed: {
        ...mapState(['payment', 'public_token']),
    },
    watch: {
        ocr() {
            this.error = false
        },
    },
    methods: {
        async get_ocr() {
            this.error = false
            this.loading = true
            await this.get_public_token()
            try {
                let response = await this.api_get({ url: `/public--ocr-numbers/${this.ocr}/${this.public_token}` })

                await this.update_key_in_state_property({
                    property: 'payment',
                    key: 'ocr',
                    data: { ...response.data },
                })
                // Emit the canonical OCR from the lookup, not the raw input — a
                // reference number resolves to its OCR here, which the payment
                // step requires (ADA-4286 B1).
                this.$emit('ocr', response.data.ocr)

            } catch {
                this.error = true
                this.error_text = this.translate('common.ocr_number_error')
            }
            this.loading = false
        },
        ...mapActions(['update_key_in_state_property']),
    },
    beforeCreate() {},
    created() {},
    beforeMount() {},
    mounted() {
        const suggested_ocr = this.deep_get(this.payment, 'ocr.suggested_ocr')
        if (suggested_ocr) {
            this.ocr = suggested_ocr
            this.$nextTick(() => {
                if (this.ocr.length > 0) {
                    this.get_ocr()
                }
            })
        }
    },
    beforeUpdate() {},
    updated() {},
    beforeUnmount() {},
}
</script>

<style scoped lang="sass"></style>
